<div class="container" *ngIf="type === undefined">
    <div class="row justify-content-between align-items-center">
        <div class="col-12 col-lg-5">
            <div class="section-heading text-center mb-3">
                <h2>Let's connect!</h2>
                <p class="d-none d-sm-block mt-4">Feel free to either fill out the contact form below and we will reach out to you soon or contact us directly using the methods below.</p>
                <p class="d-block d-sm-none mt-4">Feel free to fill out the contact form or contact us directly.</p>
            </div>
            <div class="contact-us">
                <ul>
                    <li class="contact-info color-1 bg-hover active hover-bottom text-center p-5 m-3" (click)="openUrl('phone')">
                        <span><i class="fas fa-mobile-alt fa-3x"></i></span>
                        <a class="d-block my-2" >
                            <h3>{{contactNumber}}</h3>
                        </a>
                        <p>Give us a call M-F, 9am - 6pm.</p>
                    </li>
                    <li class="contact-info color-2 bg-hover active hover-bottom text-center p-5 m-3" (click)="openUrl('email')">
                        <span><i class="fas fa-at fa-3x"></i></span>
                        <a class="d-none d-sm-block text-center" >
                            <h3 style="font-size: 24px;">{{email}}</h3>
                        </a>
                        <a class="d-block d-sm-none text-center" >
                            <h3 style="font-size: 18px; margin-left: 0px;">{{email}}</h3>
                        </a>
                        <p>Want to skip the form? No Problem! Click me to send an email</p>
                    </li>
                </ul>
            </div>
        </div>
        <div class="col-12 col-lg-6 pt-4 pt-lg-0">
            <div class="contact-box text-center">
                <app-contact-fields></app-contact-fields>
                <p class="form-message"></p>
            </div>
        </div>
    </div>
</div> 

<div *ngIf="type === 'modal'">
    <!-- MOBILE MODAL VERSION -->
    <div class="container" fxHide fxShow.lt-md>
        <div class="row justify-content-between align-items-center">
            <div class="col-12 col-lg-5 col-sm-2" *ngIf="showContactForm === false">
                <div class="section-heading text-center mb-3">
                    <h2 style="width: 300px; margin-left: -25px">Let's connect!</h2>
                    <p class="d-block d-sm-none">Click your preferred contact type</p>
                </div>
                <div class="contact-us">
                    <ul>
                        <li class="contact-info color-1 bg-hover active hover-bottom text-center p-5 m-3" (click)="openUrl('phone')">
                            <span><i class="fas fa-mobile-alt fa-3x"></i></span>
                            <a class="d-block my-2">
                                <h3> Call/Text</h3>
                            </a>
                            <p style="margin: 0px -30px;">{{contactNumber}}<br>
                                Mon-Fri 9a - 6p
                            </p>
                        </li>
                        <li class="contact-info color-2 bg-hover active hover-bottom text-center p-5 m-3" (click)="openUrl('email')">
                            <span><i class="fas fa-at fa-3x"></i></span>
                            <a class="my-2">
                                <h3 style="font-size: 24px;">Email</h3>
                            </a>
                            <p style="margin: 0px -30px; font-size: 14px;">{{email}}<p>
                            <p>Available 24/7</p>
                        </li>
                        <li class="contact-info color-3 bg-hover active hover-bottom text-center p-5 m-3" (click)="showContactForm = true">
                            <span><i class="fas fa-envelope-open-text fa-3x"></i></span>
                            <a class="my-2">
                                <h3 style="font-size: 24px; width: 170px; margin-left: -25px;">Contact Form</h3>
                            </a>
                            <p style="margin-left: -25px"><p>
                            <p>Available 24/7</p>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-12 col-lg-6 pt-4 pt-lg-0" *ngIf="showContactForm === true">
                <span  style="margin-top: -30px; margin-left: -20px; padding-bottom: 25px;" class="row">
                    <svg style="width: 32px;position: absolute;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" (click)="showContactForm = false"><!--! Font Awesome Pro 6.1.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M256 0C114.6 0 0 114.6 0 256c0 141.4 114.6 256 256 256s256-114.6 256-256C512 114.6 397.4 0 256 0zM384 288H205.3l49.38 49.38c12.5 12.5 12.5 32.75 0 45.25s-32.75 12.5-45.25 0L105.4 278.6C97.4 270.7 96 260.9 96 256c0-4.883 1.391-14.66 9.398-22.65l103.1-103.1c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25L205.3 224H384c17.69 0 32 14.33 32 32S401.7 288 384 288z"/></svg>
                    <h3 style="text-align: center; margin-left: auto; margin-right: auto">Contact Form</h3>
                </span>
                <div class="contact-box text-center">
                    <app-contact-fields></app-contact-fields>
                    <p class="form-message"></p>
                </div>
            </div>
        </div>
    </div> 
    
    <!-- DESKTOP MODAL VERSION -->
    <div class="row justify-content-between align-items-center" fxShow fxHide.lt-md>
        <div class="col-12 col-lg-5">
            <div class="section-heading text-center mb-3">
                <h2>Let's connect!</h2>
                <p class="d-none d-sm-block mt-4">Feel free to either fill out the contact form below and we will reach out to you soon or contact us directly using the methods below.</p>
                <p class="d-block d-sm-none mt-4">Feel free to fill out the contact form or contact us directly.</p>
            </div>
            <div class="contact-us">
                <ul>
                    <li class="contact-info color-1 bg-hover active hover-bottom text-center p-5 m-3" (click)="openUrl('phone')">
                        <span><i class="fas fa-mobile-alt fa-3x"></i></span>
                        <a class="d-block my-2" >
                            <h3>{{contactNumber}}</h3>
                        </a>
                        <p>Give us a call M-F, 9am - 6pm.</p>
                    </li>
                    <li class="contact-info color-2 bg-hover active hover-bottom text-center p-5 m-3" (click)="openUrl('email')">
                        <span><i class="fas fa-at fa-3x"></i></span>
                        <a class="d-block my-2" >
                            <h3 style="font-size: 24px;">{{email}}</h3>
                        </a>
                        <p>Want to skip the form? No Problem! Send an email to the address above</p>
                    </li>
                </ul>
            </div>
        </div>
        <div class="col-12 col-lg-6 pt-4 pt-lg-0">
            <div class="contact-box text-center">
                <app-contact-fields></app-contact-fields>
                <p class="form-message"></p>
            </div>
        </div>
    </div>
</div>